<template>
    <div>
        <QuickpayPaymentLayout @back="$emit('back')">
            <template #description>
                <QuickpayPaymentOverviewDescription
                    type="payment_success"
                    :data="data"
                    class="quickpay-payment-overview-success__description"
                />
            </template>
            <template #main-content>
                <div class="quickpay-payment-overview-success__ticket">
                    <QuickpayPaymentTicket :data="data" @back="$emit('back')" />
                </div>
            </template>
        </QuickpayPaymentLayout>
        <QuickpayPaymentFeedback v-if="hasQuickpayV2FeedbackFeature" :hash="hash" :data="data" />
    </div>
</template>

<script>
import QuickpayPaymentLayout from 'vcomponents/quickpay/payment/QuickpayPaymentLayout.vue';
import QuickpayPaymentOverviewDescription from 'vcomponents/quickpay/payment/QuickpayPaymentOverviewDescription.vue';
import QuickpayPaymentTicket from 'vcomponents/quickpay/payment/QuickpayPaymentTicket.vue';
import QuickpayPaymentFeedback from 'vcomponents/quickpay/payment/QuickpayPaymentFeedback.vue';
import Feature from 'Services/Feature';

export default {
    components: {
        QuickpayPaymentLayout,
        QuickpayPaymentOverviewDescription,
        QuickpayPaymentTicket,
        QuickpayPaymentFeedback,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        hash: {
            type: String,
            required: true,
        },
    },
    emits: ['back'],
    computed: {
        hasQuickpayV2FeedbackFeature() {
            return Feature.isEnabled('quickpay-v2-feedback');
        },
    },
};
</script>

<style lang="scss" scoped>
.quickpay-payment-overview-success {
    &__description {
        max-width: 260px;

        @media (max-width: 1023px) {
            max-width: 448px;
            width: 100%;
        }
    }

    &__ticket {
        max-width: 500px;
        filter: drop-shadow(0 1px 2px rgba(16, 24, 40, 0.06))
            drop-shadow(0 1px 3px rgba(16, 24, 40, 0.1));

        @media (max-width: 1023px) {
            max-width: 448px;
            width: 100%;
        }
    }
}
</style>
